export const getOrThrow = <T>(value: T, errorMessage: string): NonNullable<T> =>
  value ??
  (() => {
    throw new Error(errorMessage);
  })();
